export const config = {
  API_URL: 'https://survey.stohrm.com/api/',
};
